export default __webpack_public_path__ + "static/media/37.4332c276.png";